/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Prepare_Toast_Brief_ErrorInputs */

const en_interview_prepare_toast_brief_error = /** @type {(inputs: Interview_Prepare_Toast_Brief_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to generate brief`)
};

const de_interview_prepare_toast_brief_error = /** @type {(inputs: Interview_Prepare_Toast_Brief_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bericht konnte nicht generiert werden`)
};

const fr_interview_prepare_toast_brief_error = /** @type {(inputs: Interview_Prepare_Toast_Brief_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de générer la fiche`)
};

const es_interview_prepare_toast_brief_error = /** @type {(inputs: Interview_Prepare_Toast_Brief_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo generar el informe`)
};

const it_interview_prepare_toast_brief_error = /** @type {(inputs: Interview_Prepare_Toast_Brief_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generazione della scheda non riuscita`)
};

const nl_interview_prepare_toast_brief_error = /** @type {(inputs: Interview_Prepare_Toast_Brief_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notitie genereren mislukt`)
};

const pl_interview_prepare_toast_brief_error = /** @type {(inputs: Interview_Prepare_Toast_Brief_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się wygenerować notatki`)
};

const fi_interview_prepare_toast_brief_error = /** @type {(inputs: Interview_Prepare_Toast_Brief_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiivistelmän luominen epäonnistui`)
};

const da_interview_prepare_toast_brief_error = /** @type {(inputs: Interview_Prepare_Toast_Brief_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke generere oversigt`)
};

const sv_interview_prepare_toast_brief_error = /** @type {(inputs: Interview_Prepare_Toast_Brief_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunde inte generera översikt`)
};

/**
* | output |
* | --- |
* | "Failed to generate brief" |
*
* @param {Interview_Prepare_Toast_Brief_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_prepare_toast_brief_error = /** @type {((inputs?: Interview_Prepare_Toast_Brief_ErrorInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Prepare_Toast_Brief_ErrorInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_prepare_toast_brief_error(inputs)
	if (locale === "fr") return fr_interview_prepare_toast_brief_error(inputs)
	if (locale === "es") return es_interview_prepare_toast_brief_error(inputs)
	if (locale === "it") return it_interview_prepare_toast_brief_error(inputs)
	if (locale === "nl") return nl_interview_prepare_toast_brief_error(inputs)
	if (locale === "pl") return pl_interview_prepare_toast_brief_error(inputs)
	if (locale === "fi") return fi_interview_prepare_toast_brief_error(inputs)
	if (locale === "da") return da_interview_prepare_toast_brief_error(inputs)
	if (locale === "sv") return sv_interview_prepare_toast_brief_error(inputs)
	return en_interview_prepare_toast_brief_error(inputs)
});